// Carrier detection by number prefix, and where a visitor lands after an attempt.
//
//   MegaCom (Alfa Telecom): 55X, 75X, 99X       -> MegaCom backend (SMS code flow)
//   Beeline (Sky Mobile), official ranges:      -> Beeline backend (subscribe)
//       77Y XXXXXX                                 (770-779)
//       220-227 XXXXXX
//       228 0XXXXX, 228 7XXXXX, 228 8XXXXX, 228 9XXXXX   (228 1-6 are NOT Beeline)
//       600 XXXXXX
//   anything else                               -> no backend call, straight to /<lp>/nur/failed
import { toNationalNumber } from './msisdn';

const MEGACOM = /^(55|75|99)/;
const BEELINE = /^(77|22[0-7]|228[0789]|600)/;

// 'megacom' | 'beeline' | null (invalid number, or a number outside both carriers)
export function carrierOf(raw) {
  const national = toNationalNumber(raw);
  if (national === null) return null;
  if (MEGACOM.test(national)) return 'megacom';
  if (BEELINE.test(national)) return 'beeline';
  return null;
}

export const isBeeline = (raw) => carrierOf(raw) === 'beeline';
export const isMegacom = (raw) => carrierOf(raw) === 'megacom';

// /<lp>/<carrier>/<success|failed>. A number outside both carriers always ends on /<lp>/nur/failed.
export function resultPath(lp, carrier, outcome, search = '') {
  if (carrier !== 'megacom' && carrier !== 'beeline') return `/${lp}/nur/failed${search}`;
  return `/${lp}/${carrier}/${outcome}${search}`;
}
